import React from 'react';
import {
  Checkbox,
  Grid,
  SvgIconProps,
  Typography,
  makeStyles,
} from '@material-ui/core';
import clsx from 'clsx';
import CheckIcon from '@material-ui/icons/Check';
import i18n from 'i18n';
import styles from './styles';

const useStyles = makeStyles(styles);

interface GraphOptionProps {
  name: string;
  labelKey: string;
  selectedGraph: string;
  icon: (props: SvgIconProps) => JSX.Element;
  onChange: React.Dispatch<React.SetStateAction<'doughnut' | 'bar' | string>>;
}

const GraphOption = ({
  name,
  labelKey,
  selectedGraph,
  icon: Icon,
  onChange,
}: GraphOptionProps) => {
  const classes = useStyles();
  const isSelected = selectedGraph === name;

  return (
    <Grid
      item
      className={clsx(classes.options, {
        [classes.optionsSelected]: isSelected,
      })}
      onClick={() => onChange(name)}
      alignItems="center"
    >
      <Checkbox
        onChange={() => onChange(name)}
        checked={isSelected}
        id={`${name}-graph`}
        icon={<CheckIcon className={classes.ghostCheckIcon} />}
        checkedIcon={<CheckIcon className={classes.checkIcon} />}
      />
      <Typography
        className={clsx(classes.activeAllText, {
          [classes.optionTextSelected]: isSelected,
        })}
      >
        {i18n.t(labelKey)}
      </Typography>
      <Icon
        className={clsx(classes.activeAllText, {
          [classes.optionTextSelected]: isSelected,
        })}
      />
    </Grid>
  );
};
export default GraphOption;
